import firebase from './firebase';

var db = firebase.firestore();

export default {
    add(payload) {
        return new Promise(resolve => {
            db.collection('car_locations').doc(payload.email).set(payload);
        });
    },
    get(cb) {
        db.collection('car_locations').onSnapshot((snap) => {
            var cars = [];
            var time = new Date().getTime() / 1000;
            snap.forEach((doc) => {
                var data = doc.data();
                data.id = doc.id;
                if(time < (data.time / 1000) + 1800)
                    cars.push(data);
            });
            cb(cars);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/CarService.js